import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { TranslationService } from "@services/translation.service";
import { tap } from "rxjs/operators";
import { TranslateUpdateComponent } from "./translate-update/translate-update.component";
import { PropertiesService } from "@scaffold/services/properties.service";

@Component({
  selector: "app-translation-key",
  templateUrl: "./translation-key.component.html",
  styleUrls: ["./translation-key.component.scss"],
})
export class TranslationKeyComponent implements OnInit {
  @Input() param
  @Input() label
  @Input() selectedItem;
  @Input() rootItem;
  @Input() item: any;
  @Input() parentView: any;
  @Output() changed = new EventEmitter();
  dialogRef: ScaffoldDialogRef;
  options = [];
  hasErrors: boolean;
  hasLoaded: boolean;
  translation: any;
  sourceLanguage$: any;
  selectedKey;
  constructor(
    private translationService: TranslationService,
    public dialog: ScaffoldDialogService,
    public properties: PropertiesService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selectedKey = this.selectedItem?.[this?.param] || "";
    this.sourceLanguage$ = this.translationService.getSourceLanguage$().pipe(
      tap(({ hasErrors, hasLoaded, translation }) => {
        this.hasErrors = hasErrors;
        this.hasLoaded = hasLoaded;
        this.translation = translation;
        if (!hasErrors && translation && Object.keys(translation).length) {
          const options = Object.keys(translation)
            .map((key) => ({
              label:key,
              key,
              value: translation[key],
            }))
            .sort((a, b) => (a.key > b.key ? 1 : a.key < b.key ? -1 : 0));

          this.options = [{key:'',label:'--none--'},...options]  
          this.cd.detectChanges();
        }
      })
    );
  }

  updateValue(key) {
    this.selectedItem[this.param] = key?.value;
    this.properties.changeValue();
    this.changed.emit(key?.value);
    this.cd.detectChanges()
  }

  openUpdateTranslation() {
    this.dialogRef = this.dialog.open(TranslateUpdateComponent, {
      context: {
        data: {
          initialSelectedKey: this.selectedKey,
        },
      },
    } as any);
    this.dialogRef.onClose.subscribe((result) => {
      if (result?.key) {
        this.selectedKey = result.key
        this.updateValue(result.key)
      }
    });
  }
}
